import { render, staticRenderFns } from "./VideoSelector.vue?vue&type=template&id=4823a923"
import script from "./VideoSelector.vue?vue&type=script&lang=js"
export * from "./VideoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports